const skills = {
  ors: [
    {
      mascot: 'whatIs',
      balloon: 'staticPages.newSkills.ors.pages.page1.title',
      type: 'warning',
      texts: ['staticPages.newSkills.ors.pages.page1.p1', 'staticPages.newSkills.ors.pages.page1.p2'],
    },
    {
      mascot: 'whatIs',
      balloon: 'staticPages.newSkills.ors.pages.page2.title',
      type: 'warning',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.ors.pages.page2.ul.li1',
            'staticPages.newSkills.ors.pages.page2.ul.li2',
            'staticPages.newSkills.ors.pages.page2.ul.li3',
            'staticPages.newSkills.ors.pages.page2.ul.li4',
          ],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.ors.pages.page3.title',
      border: 'large',
      texts: [
        {
          tag: 'h3',
          text: 'staticPages.newSkills.ors.pages.page3.h1',
        },
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.ors.pages.page3.ul.li1',
            'staticPages.newSkills.ors.pages.page3.ul.li2',
            'staticPages.newSkills.ors.pages.page3.ul.li3',
          ],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.ors.pages.page4.title',
      border: 'large',
      texts: [
        {
          tag: 'h3',
          text: 'staticPages.newSkills.ors.pages.page4.h1',
        },
        {
          tag: 'ul',
          listType: 'number',
          texts: ['staticPages.newSkills.ors.pages.page4.ul.li1'],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.ors.pages.page5.title',
      border: 'large',
      texts: [
        {
          tag: 'h3',
          text: 'staticPages.newSkills.ors.pages.page5.h1',
        },
        {
          tag: 'ul',
          listType: 'number',
          texts: ['staticPages.newSkills.ors.pages.page5.ul1.li1'],
        },
        {
          tag: 'h3',
          text: 'staticPages.newSkills.ors.pages.page5.h2',
        },
        {
          tag: 'ul',
          listType: 'number',
          texts: ['staticPages.newSkills.ors.pages.page5.ul2.li1'],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.ors.pages.page6.title',
      type: 'warning',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: ['staticPages.newSkills.ors.pages.page6.ul.li1', 'staticPages.newSkills.ors.pages.page6.ul.li2'],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.ors.pages.page7.title',
      type: 'warning',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.ors.pages.page7.ul1.li1',
            'staticPages.newSkills.ors.pages.page7.ul1.li2',

            {
              tag: 'li',
              texts: [
                'staticPages.newSkills.ors.pages.page7.ul1.li3',
                {
                  tag: 'ul',
                  texts: [
                    'staticPages.newSkills.ors.pages.page7.ul2.li1',
                    'staticPages.newSkills.ors.pages.page7.ul2.li2',
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.ors.pages.page8.title',
      type: 'warning',
      border: 'large',
      texts: [
        {
          tag: 'h3',
          text: 'staticPages.newSkills.ors.pages.page8.h',
        },
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.ors.pages.page8.ul.li1',
            'staticPages.newSkills.ors.pages.page8.ul.li2',
            'staticPages.newSkills.ors.pages.page8.ul.li3',
            'staticPages.newSkills.ors.pages.page8.ul.li4',
          ],
        },
      ],
    },
    {
      mascot: 'whenToWorry',
      balloon: 'staticPages.newSkills.ors.pages.page9.title',
      type: 'danger',
      border: 'large',
      innerTitle: 'staticPages.newSkills.ors.pages.page9.innerTitle',
      texts: [
        {
          tag: 'ul',
          texts: [
            'staticPages.newSkills.ors.pages.page9.ul.li1',
            'staticPages.newSkills.ors.pages.page9.ul.li2',
            'staticPages.newSkills.ors.pages.page9.ul.li3',
            'staticPages.newSkills.ors.pages.page9.ul.li4',
          ],
        },
      ],
    },
  ],
  medicine: [
    {
      mascot: 'whatIs',
      balloon: 'staticPages.newSkills.medicine.pages.page1.title',
      type: 'warning',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.medicine.pages.page1.ul.li1',
            'staticPages.newSkills.medicine.pages.page1.ul.li2',
            'staticPages.newSkills.medicine.pages.page1.ul.li3',
            'staticPages.newSkills.medicine.pages.page1.ul.li4',
          ],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.medicine.pages.page2.title',
      type: 'warning',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.medicine.pages.page2.ul.li1',
            'staticPages.newSkills.medicine.pages.page2.ul.li2',
            'staticPages.newSkills.medicine.pages.page2.ul.li3',
            'staticPages.newSkills.medicine.pages.page2.ul.li4',
          ],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.medicine.pages.page3.title',
      type: 'warning',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.medicine.pages.page3.ul.li1',
            'staticPages.newSkills.medicine.pages.page3.ul.li2',
            'staticPages.newSkills.medicine.pages.page3.ul.li3',
            'staticPages.newSkills.medicine.pages.page3.ul.li4',
          ],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.medicine.pages.page4.title',
      type: 'warning',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.medicine.pages.page4.ul.li1',
            'staticPages.newSkills.medicine.pages.page4.ul.li2',
            'staticPages.newSkills.medicine.pages.page4.ul.li3',
            'staticPages.newSkills.medicine.pages.page4.ul.li4',
          ],
        },
      ],
    },
    {
      mascot: 'whenToWorry',
      balloon: 'staticPages.newSkills.medicine.pages.page5.title',
      type: 'warning',
      border: 'large',
      texts: [
        { tag: 'h3', text: 'staticPages.newSkills.medicine.pages.page5.h' },
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.medicine.pages.page5.ul.li1',
            'staticPages.newSkills.medicine.pages.page5.ul.li2',
            'staticPages.newSkills.medicine.pages.page5.ul.li3',
          ],
        },
      ],
    },
    {
      mascot: 'whenToWorry',
      balloon: 'staticPages.newSkills.medicine.pages.page6.title',
      type: 'warning',
      border: 'large',
      texts: [
        { tag: 'h3', text: 'staticPages.newSkills.medicine.pages.page6.h' },
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.medicine.pages.page6.ul.li1',
            'staticPages.newSkills.medicine.pages.page6.ul.li2',
            'staticPages.newSkills.medicine.pages.page6.ul.li3',
          ],
        },
      ],
    },
  ],
  inhaler: [
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.inhaler.pages.page1.title',
      type: 'warning',
      texts: [
        { tag: 'h3', text: 'staticPages.newSkills.inhaler.pages.page1.h' },
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.inhaler.pages.page1.ul.li1',
            'staticPages.newSkills.inhaler.pages.page1.ul.li2',
            'staticPages.newSkills.inhaler.pages.page1.ul.li3',
          ],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.inhaler.pages.page2.title',
      border: 'large',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.inhaler.pages.page2.ul.li1',
            'staticPages.newSkills.inhaler.pages.page2.ul.li2',
            'staticPages.newSkills.inhaler.pages.page2.ul.li3',
            'staticPages.newSkills.inhaler.pages.page2.ul.li4',
            'staticPages.newSkills.inhaler.pages.page2.ul.li5',
            'staticPages.newSkills.inhaler.pages.page2.ul.li6',
            'staticPages.newSkills.inhaler.pages.page2.ul.li7',
          ],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.inhaler.pages.page3.title',
      type: 'warning',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.inhaler.pages.page3.ul.li1',
            'staticPages.newSkills.inhaler.pages.page3.ul.li2',
          ],
        },
      ],
    },
    {
      mascot: 'whatToDo',
      balloon: 'staticPages.newSkills.inhaler.pages.page4.title',
      type: 'warning',
      texts: [
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.inhaler.pages.page4.ul.li1',
            'staticPages.newSkills.inhaler.pages.page4.ul.li2',
            'staticPages.newSkills.inhaler.pages.page4.ul.li3',
          ],
        },
      ],
    },
    {
      mascot: 'whenToWorry',
      balloon: 'staticPages.newSkills.inhaler.pages.page5.title',
      type: 'warning',
      border: 'large',
      texts: [
        {
          tag: 'h3',
          text: 'staticPages.newSkills.inhaler.pages.page5.h',
        },
        {
          tag: 'ul',
          listType: 'number',
          texts: [
            'staticPages.newSkills.inhaler.pages.page5.ul.li1',
            'staticPages.newSkills.inhaler.pages.page5.ul.li2',
            'staticPages.newSkills.inhaler.pages.page5.ul.li3',
            'staticPages.newSkills.inhaler.pages.page5.ul.li4',
            'staticPages.newSkills.inhaler.pages.page5.ul.li5',
            'staticPages.newSkills.inhaler.pages.page5.ul.li6',
          ],
        },
      ],
    },
  ],
};

export default skills;
